<template>
  <div class="image-viewer" :class="{ 'zoomable': zoomable }">
    <div v-if="zoomable" class=" zoomable">
      <img class="dropzone-img" :src="computedFilePath" @click="showModal = true">
      <portal to="imgviewer-modal">
        <ModalBase :show-modal="showModal" @close-modal="showModal = false" widthMd class="image-viewer--modal">
          <template v-slot:maincontent>
            <img class="image-viewer--modal__img" :src='computedFilePath' @click="showModal = false">
          </template>
        </ModalBase>
      </portal>
    </div>
    <img v-else class="dropzone-img" :src="computedFilePath">
  </div>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
export default {
  name: "ImageViewer",
  components: {
    ModalBase
  },
  props: {
    zoomable: {
      type: Boolean,
      default: false
    },
    filePath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      updatedFilePath: null,
      showModal: false
    }
  },
  computed: {
    computedFilePath () {
      return (this.updatedFilePath) ? this.updatedFilePath : this.filePath
    }
  },
  methods: {
    updateFilePath (filepath) {
      this.updatedFilePath = filepath
    }
  },
}
</script>

<style lang="scss">
  .image-viewer {
    width: 100%;
    height: 100%;
    position: relative;
    &.zoomable { cursor: pointer; }
    &--modal {
      &__img {
        position: absolute;
        object-fit: contain;
        height: 100%;
        width: 100%;
        &.nofit {
          object-fit: none;
        }
      }
      .gk-modal-wrapper {
        z-index: 9100;
        .gk-modal {
          max-width: 100%;
          .gk-modal-content {
            .close-btn {
              z-index: 9200;
            }
          }
        }
      }
    }
  }
</style>
